function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { InternalSessionState } from '../../core/session-controller/internal-session-state';
import { sdkLogger } from '../../logger';
export var AdvertBufferingBreadcrumbAddon = /*#__PURE__*/ function() {
    "use strict";
    function AdvertBufferingBreadcrumbAddon(session) {
        var _this = this;
        _class_call_check(this, AdvertBufferingBreadcrumbAddon);
        _define_property(this, "name", 'Advert Buffering Breadcrumb Addon');
        _define_property(this, "receivedAdBreaks", null);
        _define_property(this, "currentAdBreak", null);
        _define_property(this, "currentAd", null);
        _define_property(this, "logger", sdkLogger.withContext('DLA'));
        _define_property(this, "currentState", InternalSessionState.Initialized);
        _define_property(this, "currentPosition", void 0);
        _define_property(this, "handleAdBreakDataReceived", function(adBreaks) {
            _this.receivedAdBreaks = adBreaks;
        });
        _define_property(this, "handleAdBreakStarted", function(adBreak) {
            _this.currentAdBreak = adBreak;
        });
        _define_property(this, "handleAdBreakFinished", function() {
            _this.currentAdBreak = null;
        });
        _define_property(this, "handleAdStarted", function(ad) {
            _this.currentAd = ad;
        });
        _define_property(this, "handleAdFinished", function() {
            _this.currentAd = null;
        });
        _define_property(this, "handleSessionStateChanged", function(nextState) {
            if (_this.currentState !== InternalSessionState.Rebuffering && nextState === InternalSessionState.Rebuffering) {
                _this.logRebufferingBreadcrumbs();
            }
            _this.currentState = nextState;
        });
        _define_property(this, "handlePlaybackTimelineChanged", function(param) {
            var position = param.position;
            _this.currentPosition = position;
        });
        _define_property(this, "logRebufferingBreadcrumbs", function() {
            if (!_this.receivedAdBreaks) {
                return;
            }
            if (_this.currentAdBreak) {
                var _this_currentAd, _this_currentAd1;
                var adId = ((_this_currentAd = _this.currentAd) === null || _this_currentAd === void 0 ? void 0 : _this_currentAd.id) || 'unknown';
                var adName = ((_this_currentAd1 = _this.currentAd) === null || _this_currentAd1 === void 0 ? void 0 : _this_currentAd1.name) || 'unknown';
                _this.logger.breadcrumb("Rebuffering in break id: ".concat(_this.currentAdBreak.id, ", ad id: ").concat(adId, ", ad name: ").concat(adName));
            } else {
                _this.logger.breadcrumb("Rebuffering in content at adapted position: ".concat(_this.currentPosition));
            }
        });
        session.onAdBreakDataReceived(this.handleAdBreakDataReceived);
        session.onAdBreakStarted(this.handleAdBreakStarted);
        session.onAdBreakFinished(this.handleAdBreakFinished);
        session.onAdStarted(this.handleAdStarted);
        session.onAdFinished(this.handleAdFinished);
        session.onStateChanged(this.handleSessionStateChanged);
        session.onPlaybackTimelineUpdated(this.handlePlaybackTimelineChanged);
    }
    _create_class(AdvertBufferingBreadcrumbAddon, [
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return AdvertBufferingBreadcrumbAddon;
}();

//# sourceMappingURL=advert-buffering-breadcrumb-addon.js.map